import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LeadCard } from "@/components/portal/LeadCard";

export default function Intakes() {
  const [leads, setLeads] = useState([]);
  useEffect(() => {
    let cancelled = false;
    api.get("/leads")
      .then((r) => { if (!cancelled) setLeads(r.data); })
      .catch(() => { /* lead list reloads on next mount */ });
    return () => { cancelled = true; };
  }, []);
  return (
    <div className="fade-in-up">
      <div className="mb-8"><div className="text-caption text-[#B91C1C] mb-2">INTAKE QUEUE</div><h1 className="font-serif text-3xl font-bold text-[#0A192F]">Referrals & Contact Submissions</h1></div>
      <div className="space-y-3">
        {leads.length === 0 && <div className="text-slate-500">No submissions yet.</div>}
        {leads.map((l) => <LeadCard key={l.id} l={l} />)}
      </div>
    </div>
  );
}
